import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Logo } from "../components/Logo";
import { adminLogin } from "../lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
    const nav = useNavigate();
    const [email, setEmail] = useState("info@centrosicurezzaconsulenze.net");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        document.title = "Admin | SafetyDesk81";
        if (localStorage.getItem("sd81_admin_token")) nav("/admin/iscrizioni");
    }, [nav]);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const { token, email: em } = await adminLogin(email, password);
            localStorage.setItem("sd81_admin_token", token);
            localStorage.setItem("sd81_admin_email", em);
            toast.success("Accesso effettuato");
            nav("/admin/iscrizioni");
        } catch (err) {
            const msg = err?.response?.data?.detail || "Credenziali non valide";
            toast.error(msg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen grid lg:grid-cols-2">
            <div className="hidden lg:flex bg-navy-950 text-white p-14 relative overflow-hidden">
                <div aria-hidden className="absolute inset-0 bg-grid-navy opacity-40" />
                <div aria-hidden className="absolute -bottom-24 -left-24 w-96 h-96 bg-gold-400/15 blur-3xl rounded-full" />
                <div className="relative z-10 flex flex-col justify-between h-full w-full">
                    <Logo variant="light" size="lg" />
                    <div>
                        <div className="chapter-chip mb-6"><span className="num">A</span><span className="text-white/50">Area riservata</span></div>
                        <h1 className="font-display font-black text-white text-5xl leading-tight">Gestione iscrizioni evento SafetyDesk81.</h1>
                        <p className="mt-6 text-white/60 max-w-md">Visualizza, esporta e organizza le iscrizioni ricevute dalla landing. Area indipendente dall'app SafetyDesk81.</p>
                    </div>
                </div>
            </div>

            <div className="flex items-center justify-center px-5 py-10 bg-navy-50">
                <motion.form
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    onSubmit={submit}
                    data-testid="admin-login-form"
                    className="w-full max-w-md bg-white rounded-3xl border border-navy-100 shadow-card p-8 md:p-10"
                >
                    <div className="lg:hidden mb-6"><Logo size="md" /></div>
                    <div className="text-[11px] font-mono tracking-widest text-gold-500 uppercase">Area riservata</div>
                    <h2 className="mt-1 font-display font-black text-navy-950 text-3xl">Bentornato</h2>
                    <p className="mt-2 text-navy-500 text-sm">Accedi per gestire le iscrizioni all'evento</p>

                    <label className="block mt-8">
                        <span className="block text-xs font-semibold text-navy-700 mb-1.5 uppercase tracking-wider">Email</span>
                        <input
                            data-testid="admin-email"
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="w-full bg-navy-50 border border-navy-100 rounded-xl px-4 py-3 text-navy-950 outline-none focus:border-navy-950 focus:bg-white transition-all"
                        />
                    </label>
                    <label className="block mt-4">
                        <span className="block text-xs font-semibold text-navy-700 mb-1.5 uppercase tracking-wider">Password</span>
                        <input
                            data-testid="admin-password"
                            type="password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full bg-navy-50 border border-navy-100 rounded-xl px-4 py-3 text-navy-950 outline-none focus:border-navy-950 focus:bg-white transition-all"
                        />
                    </label>
                    <button
                        data-testid="admin-submit"
                        type="submit"
                        disabled={loading}
                        className="mt-8 w-full bg-navy-950 hover:bg-navy-900 disabled:opacity-70 text-white font-semibold py-3.5 rounded-full transition-all inline-flex items-center justify-center gap-2"
                    >
                        {loading ? <><span className="w-4 h-4 rounded-full border-2 border-white/30 border-t-white animate-spin" /> Accesso…</> : "Accedi"}
                    </button>
                </motion.form>
            </div>
        </div>
    );
}
